<template>
  <validation-provider
    #default="{ errors }"
    :name="defaultName"
    mode="passive"
    :rules="rules + '|min:7'"
    vid="MobileInput"
    ref="mobileValidation"
  >
    <b-form-group :description="description" :label="label" :label-for="id">
      <b-form-input
        :state="isValid && errors.length === 0"
        :name="name"
        :id="id"
        v-bind="$attrs"
        v-on="$listeners"
        v-model="model"
        v-mask="'##########'"
        autocomplete="off"
        @paste="onPaste"
      />

      <small :class="isValid ? 'text-success' : 'text-danger'">{{
        errors[0] || message
      }}</small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { BFormGroup, BFormInput } from "bootstrap-vue";
import { required, min } from "@validations";
import debounce from "lodash.debounce";
import axios from "@axios";
export default {
  components: {
    ValidationProvider,
    BFormInput,
    BFormGroup,
  },
  props: {
    id: {
      type: String,
      default: () => "mobile-input",
    },
    name: {
      type: String,
    },
    rules: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => "اسم المستخدم",
    },
    description: {
      type: String,
      default: () => "",
    },
    checkEp: {
      type: String,
      default: () => "check-unique",
    },
    isMinistry: {
      type: Boolean,
      default: () => false,
    },

    value: {
      type: String,
    },
  },
  data() {
    return {
      required,
      min,
      isValid: null,
      message: null,
      loading: false,
      initialValue: null,
    };
  },
  methods: {
    onPaste(e) {
      this.dontSetInitialValue = true;
    },
    async checkIfValid(val) {
      return await axios.get(this.isMinistry == true ? `v2/ministry/${this.checkEp}` :`v2/${this.checkEp}`, {
        params: {
          search: val,
          field: "mobile",
          isMinistry: this.isMinistry,
        },
      });
    },
  },

  watch: {
    model: debounce(async function (val) {
      if (val && val !== this.initialValue) {
        const res = await this.checkIfValid(val);
        if (res.status === 400) {
          this.isValid = false;
          this.message = res.data.message;
          this.$refs["mobileValidation"].applyResult({
            errors: [this.message],
            valid: false,
            failedRules: {},
          });
          this.$emit("validationChanged", false);
        } else {
          this.$refs["mobileValidation"].applyResult({
            errors: [],
            valid: true,
            failedRules: {},
          });
          this.$emit("validationChanged", true);
          this.message = res.data.message;
          this.isValid = true;
        }
      } else {
        this.isValid = null;
        this.message = null;
        this.$emit("validationChanged", true);
      }
    }, 200),
    value(val, oldVal) {
      if (val && this.dontSetInitialValue) {
        this.initialValue = "";
      } else if (val && (oldVal === undefined || oldVal === null)) {
        this.initialValue = val;
      }
    },
  },
  computed: {
    defaultName() {
      return this.name || this.label;
    },
    model: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>
